import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import WirelessLocationFormA from './wireless-location-form.component';
import WirelessSubscriptionFormA from './wireless-subscription-form.component';
import WirelessBusinessFormA from './wireless-business-form.component';
import { newMobileSubscriptionActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer";
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import Icons from '../../../../../icon';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import { Milestone } from '../../../../../common/milestone/milestone.component';
import { Loading } from '../../../../../common/loading';
import { requestDetailsActions } from "./../../../../../../store/external/request-reducer/request-details.reducer";

class NewMobileSubscription extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLocationForm: true,
            isSubscriptionForm: false,
            isBusinessForm: false,
            activeIndex: 0,
            isLoading:true,
            milestones: [
                "location",
                "subscription",
                "business_justification"
            ]

        }
    }

    componentDidMount() {
        this.props.disableAutoScroll(true);
    }

    componentWillMount() {
        this.props.getNewMobileFormData().then(() => {
            this.setState({ isLoading: false });
        });       
    }

    componentWillUnmount() {
        const { updateOrderRequest } = this.props;
        updateOrderRequest(false);
        this.props.resetNewMobileForm();
    }

    nextAction = () => {

        const { isLocationForm, isSubscriptionForm } = this.state;
        const { disableROBCheckbox } = this.props;
        this.props.disableAutoScroll(false);
        if (isSubscriptionForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: false,
                isBusinessForm: true,
                activeIndex: 2              
            });           
        }
        else if (isLocationForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1
            });
            this.props.getNewMobileFormData()
            disableROBCheckbox(true);
        }
    }

    prevAction = () => {

        const { isSubscriptionForm, isBusinessForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isBusinessForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false,
                activeIndex: 1
            });
        }
        else if (isSubscriptionForm) {
            this.setState({
                isLocationForm: true,
                isSubscriptionForm: false,
                isBusinessForm: false,
                activeIndex: 0
            });
            if(this.props.wirelessLocationFormA.locationId !== -1){
                this.props.disableAutoScroll(true);
            } else{
                this.props.disableAutoScroll(false);
            } 
            disableROBCheckbox(false);
        }

    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose !== null && modalClose !== undefined) {
            modalClose();
        }
    }

    displayForm = () => {
        const { isLocationForm, isSubscriptionForm } = this.state;
        const { modalMessage,closeAction } = this.props;
        let form;

        if (isLocationForm) {
            form = <WirelessLocationFormA disableAutoScroll={this.props.disableAutoScroll} onClickCancel={this.onClickCancel} nextAction={this.nextAction} />
        } else if (isSubscriptionForm) {
            form = <WirelessSubscriptionFormA disableAutoScroll={this.props.disableAutoScroll} onClickCancel={this.onClickCancel} nextAction={this.nextAction} prevAction={this.prevAction}/>
        } else {
            form = <WirelessBusinessFormA isUpdate={this.props.wirelessLocationFormA.isAmending} hideRequestModal={this.props.hideRequestModal} closeAction={closeAction} onClickCancel={this.onClickCancel} prevAction={this.prevAction} modalMessage={modalMessage}/>
        }

        return (form);
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {        
        if (this.state.isLoading) {
            return <Loading />
        }
        return (
            <div>                
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <h6 className="plan-detail-sub-header"><Translation translationKey="order_request_details" /></h6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <Milestone milestones={this.state.milestones} activeIndex={this.state.activeIndex}/>
                    </Col>
                </Row>
                {this.displayForm()}
            </div>
        );
    }
};

export default connect(
    state => {
        const { createRequest, translation } = state;
        const { wirelessLocationFormA } = state.form;
        return {
            createRequest
            , wirelessLocationFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newMobileSubscriptionActions
                , createRequestActions, requestDetailsActions),
            dispatch
        )
)(NewMobileSubscription);